// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.result-container {
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  margin: 20px auto;
}

.result-header {
  display: inline-block;
  margin: 0;
  padding-bottom: 1rem;
  position: relative;
}
.result-header:after {
  position: absolute;
  content: "";
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 3px;
  background: #656d4a;
  border-radius: 8px;
}

.result-content {
  width: 92%;
  margin: 0 auto;
  position: relative;
}

.result-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  width: 800px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.3);
  transform: translateX(-50%);
}

.content-block {
  width: 45%;
  display: inline-block;
  margin: 2rem;
  vertical-align: top;
}
@media (max-width: 1280px) {
  .content-block {
    width: 40%;
  }
}
@media (max-width: 800px) {
  .content-block {
    width: 80%;
  }
}
.content-block .items {
  background: #fffffe;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  border-top: 15px solid #656d4a;
  border-radius: 8px;
  text-align: left;
}
.content-block .items-head p {
  padding: 5px 20px;
  margin: 10px 10px 0 10px;
  color: #656d4a;
  font-weight: bold;
  font-size: 20px;
}
.content-block .items-head hr {
  width: 20%;
  margin: 0px 30px;
  border: 1px solid #656d4a;
}
.content-block .items-body {
  padding: 5px;
  margin: 5px;
}
.content-block .items-body-content {
  font-size: 16px;
  border: 1px solid transparent;
}
.content-block .items-body-content i {
  align-self: center;
  font-size: 15px;
  color: #656d4a;
  font-weight: bold;
  animation: icon 1.5s infinite forwards;
}
.content-block .span_header {
  display: inline-block;
  margin: 0 !important;
}

.search-result-loading {
  text-align: center;
  margin: 20px auto;
}

.items-list {
  margin: 0 0 10px 10px;
}
.items-list .ui.accordion:not(.styled) .accordion .title ~ .content:not(.ui) {
  padding: 0 !important;
}
.items-list .ui.accordion:not(.styled) .title ~ .content:not(.ui) {
  padding: 0 !important;
  margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/SearchResult/SearchResult.scss","webpack://./src/scss/variables.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AADF;;AAIA;EACE,qBAAA;EAEA,SAAA;EACA,oBAAA;EACA,kBAAA;AAFF;AAIE;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBCxBQ;EDyBR,kBAAA;AAFJ;;AAMA;EACE,UAAA;EACA,cAAA;EACA,kBAAA;AAHF;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,2BAAA;AAHF;;AAMA;EACE,UAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AAHF;AAKE;EANF;IAOI,UAAA;EAFF;AACF;AAIE;EAVF;IAWI,UAAA;EADF;AACF;AAGE;EACE,mBAAA;EACA,wEAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AADJ;AAIE;EACE,iBAAA;EACA,wBAAA;EACA,cCvEQ;EDwER,iBAAA;EACA,eAAA;AAFJ;AAKE;EACE,UAAA;EACA,gBAAA;EACA,yBAAA;AAHJ;AAME;EACE,YAAA;EACA,WAAA;AAJJ;AAOE;EACE,eAAA;EACA,6BAAA;AALJ;AAQE;EACE,kBAAA;EACA,eAAA;EACA,cC/FQ;EDgGR,iBAAA;EACA,sCAAA;AANJ;AASE;EACE,qBAAA;EACA,oBAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,iBAAA;AARF;;AAWA;EACE,qBAAA;AARF;AAYM;EACE,qBAAA;AAVR;AAcI;EACE,qBAAA;EACA,iBAAA;AAZN","sourcesContent":["@use '../../scss/variables.scss';\n\n.result-container {\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: relative;\n  margin: 20px auto;\n}\n\n.result-header {\n  display: inline-block;\n\n  margin: 0;\n  padding-bottom: 1rem;\n  position: relative;\n\n  &:after {\n    position: absolute;\n    content: '';\n    left: 0;\n    bottom: -1px;\n    width: 100%;\n    height: 3px;\n    background: variables.$mainGreen;\n    border-radius: 8px;\n  }\n}\n\n.result-content {\n  width: 92%;\n  margin: 0 auto;\n  position: relative; // 必須加上相對定位以讓 ::before 使用\n}\n\n.result-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 800px;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.3);\n  transform: translateX(-50%);\n}\n\n.content-block {\n  width: 45%;\n  display: inline-block;\n  margin: 2rem;\n  vertical-align: top;\n\n  @media (max-width: 1280px) {\n    width: 40%;\n  }\n\n  @media (max-width: 800px) {\n    width: 80%;\n  }\n\n  .items {\n    background: #fffffe;\n    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);\n    border-top: 15px solid variables.$mainGreen;\n    border-radius: 8px;\n    text-align: left;\n  }\n\n  .items-head p {\n    padding: 5px 20px;\n    margin: 10px 10px 0 10px;\n    color: variables.$mainGreen;\n    font-weight: bold;\n    font-size: 20px;\n  }\n\n  .items-head hr {\n    width: 20%;\n    margin: 0px 30px;\n    border: 1px solid variables.$mainGreen;\n  }\n\n  .items-body {\n    padding: 5px;\n    margin: 5px;\n  }\n\n  .items-body-content {\n    font-size: 16px;\n    border: 1px solid transparent;\n  }\n\n  .items-body-content i {\n    align-self: center;\n    font-size: 15px;\n    color: variables.$mainGreen;\n    font-weight: bold;\n    animation: icon 1.5s infinite forwards;\n  }\n\n  .span_header {\n    display: inline-block;\n    margin: 0 !important;\n  }\n}\n\n.search-result-loading {\n  text-align: center;\n  margin: 20px auto;\n}\n\n.items-list {\n  margin: 0 0 10px 10px;\n\n  .ui.accordion:not(.styled) {\n    .accordion {\n      .title ~ .content:not(.ui) {\n        padding: 0 !important;\n      }\n    }\n\n    .title ~ .content:not(.ui) {\n      padding: 0 !important;\n      margin-left: 15px;\n    }\n  }\n}\n","$mainGreen: #656d4a;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
